import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { GroupChannel } from "@sendbird/chat/lib/__definition";
import { Channel, ChannelList } from "@sendbird/uikit-react";
import SendbirdProvider from "@sendbird/uikit-react/SendbirdProvider";
import { RenderChannelPreviewProps } from "SendbirdUIKitGlobal";
import { Loading } from "components/commons";
import { ACCESS_TOKEN, getItem } from "local-storage";
import moment from "moment";
import { useEffect, useState } from "react";
import { getUserLiveInfo } from "services/apis/apis";
import { IUserLiveInfo } from "services/apis/types";
import { getFromCookie, setToCookie } from "services/cookie/user-live-info";

function ChannelListPreview({ channel }: RenderChannelPreviewProps) {
  return (
    <div className="border-2 rounded-xl border-gray-800 w-full mb-4">
      <div className={`flex p-4 gap-4 justify-between items-center `}>
        <div className="flex items-center gap-4 w-full">
          <div className="w-12 shadow-sm rounded-full overflow-hidden flex justify-center items-center">
            <img
              className="h-10 w-10 shadow-sm rounded-full object-fill"
              src={
                channel.coverUrl ||
                "https://static.sendbird.com/sample/cover/cover_13.jpg"
              }
              alt=""
            />
          </div>

          <div className="w-full">
            <div className={`text-sm font-normal`}>{channel.name}</div>
            <div className="text-xs font-normal text-slate-500 w-full">
              {/* @ts-ignore */}
              {channel?.lastMessage?.sender ? (
                <div className="flex items-center justify-between w-full">
                  <div className="max-w-[160px]">
                    <span> </span>
                    <p className="truncate ...">
                      {/* @ts-ignore */}
                      {channel?.lastMessage?.sender?.nickname}:{" "}
                      {/* @ts-ignore */}
                      {channel?.lastMessage?.message}
                    </p>{" "}
                  </div>
                  <div>{moment(channel.lastMessage?.createdAt).fromNow()}</div>
                </div>
              ) : (
                "Send message"
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ChannelHeader({
  channel,
  backToChannelList,
}: {
  channel: GroupChannel;
  backToChannelList: () => void;
}) {
  return (
    <div className="flex flex-wrap justify-between items-center w-full py-2 px-3 gap-2 mt-2">
      <div className="flex-none">
        <ArrowLeftIcon className="w-6 h-6" onClick={backToChannelList} />
      </div>
      <div className="grow flex gap-2 items-center">
        <img
          alt="group"
          className="h-8 w-8 shadow-sm rounded-full object-fill"
          src={
            channel.coverUrl ||
            "https://static.sendbird.com/sample/cover/cover_13.jpg"
          }
        />
        <div>{channel?.name}</div>
      </div>
    </div>
  );
}

export function SendbirdChat() {
  const [currentChannel, setCurrentChannel] = useState<GroupChannel>();
  const [userInfo, setUserInfo] = useState<IUserLiveInfo>();
  const [isShowChannel, setIsShowChannel] = useState<boolean>(false);

  const applicationId = process.env.REACT_APP_SENDBIRD_APP_ID || "";
  const accessToken = getItem(ACCESS_TOKEN) || "";

  useEffect(() => {
    const _userInfo = getFromCookie();
    if (_userInfo) {
      setUserInfo(_userInfo);
    } else {
      getUserLiveInfo(accessToken).then((user) => {
        setUserInfo(user);
        setToCookie(user);
      });
    }
  }, []);

  const myColorSet = {
    "--sendbird-dark-background-600": "transparent",
    "--sendbird-dark-background-500": "#0F172A",
    "--sendbird-dark-primary-200": "#EC53B0",
    "--sendbird-dark-ondark-01": "#CBD5E1",
    "--sendbird-dark-background-300": "#f8fafc",
    "--sendbird-dark-ondark-02": "#ffffff",
  };

  return (
    <>
      {userInfo && userInfo?.user_id ? (
        <SendbirdProvider
          appId={applicationId}
          userId={userInfo.user_id}
          accessToken={userInfo.access_token}
          theme="dark"
          colorSet={myColorSet}
        >
          <>
            <div className={isShowChannel ? "hidden" : "h-full w-full"}>
              <ChannelList
                className="fix-width"
                renderPlaceHolderLoading={() => <Loading notFixed={true} />}
                renderChannelPreview={ChannelListPreview}
                renderHeader={() => <div className="h-0"></div>}
                onChannelSelect={(channel) => {
                  setIsShowChannel(true);
                  setCurrentChannel(channel);
                }}
                disableAutoSelect={true}
                disableUserProfile={true}
                queries={{
                  channelListQuery: {
                    includeEmpty: true,
                  },
                }}
              />
            </div>
            {isShowChannel && currentChannel ? (
              <Channel
                channelUrl={currentChannel?.url || ""}
                disableUserProfile={true}
                isLoading={false}
                renderChannelHeader={() => (
                  <ChannelHeader
                    channel={currentChannel}
                    backToChannelList={() => {
                      setIsShowChannel(false);
                    }}
                  />
                )}
              />
            ) : null}
          </>
        </SendbirdProvider>
      ) : (
        <Loading notFixed={true} />
      )}
    </>
  );
}
